import styled from "styled-components";
import Card from "./Card";
import Column from "./Column";
import Space from "./Space";

const Layout = styled(Card)`
  width: 360px;
`;

const ColumnInner = styled(Column)`
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 18px;
  padding-right: 18px;
  align-items: start;
  gap: 0px;
`;

function HomeCard({ title, subTitle, rightAction, children }) {
  return (
    <Layout>
      <ColumnInner>
        <div className="flex flex-row w-full items-center">
          <div className="text-[20px] text-primary font-medium">{title}</div>
          <div className="ml-auto">{rightAction}</div>
        </div>
        <Space height="10px" />
        <div className="text-[14px] text-secondary font-bold">{subTitle}</div>
        <Space height="10px" />
        {children}
      </ColumnInner>
    </Layout>
  );
}

export default HomeCard;
